import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { useT } from "../i18n";

export default function Footer() {
  const { t } = useT();
  return (
    <footer className="mt-24 border-t border-[var(--bb-border)] bg-[var(--bb-sand)]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="bb-overline text-[var(--bb-muted)] mb-2">ಬಾಲ ಬಸವ · {t("brand_overline")}</div>
          <p className="font-serif text-3xl text-[var(--bb-forest)] leading-tight max-w-md">
            {t("footer_heading")}
          </p>
          <p className="mt-5 text-sm text-[var(--bb-ink)]/75 leading-relaxed max-w-md">
            {t("footer_body")}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="bb-overline text-[var(--bb-muted)] mb-3">{t("footer_platform")}</div>
          <ul className="space-y-2 text-sm text-[var(--bb-ink)]">
            <li><a href="/welcome" className="bb-link" data-testid="footer-welcome">Welcome</a></li>
            <li><a href="/audio-comics" className="bb-link" data-testid="footer-audio">Audio</a></li>
            <li><a href="/sponsor-books" className="bb-link" data-testid="footer-donate">Sponsor Books</a></li>
          </ul>
        </div>

        <div className="md:col-span-4" data-testid="footer-contact">
          <div className="bb-overline text-[var(--bb-muted)] mb-3">Contact Info</div>
          <div className="space-y-3 text-sm text-[var(--bb-ink)]/85">
            <div className="flex items-start gap-2" data-testid="footer-contact-address">
              <MapPin size={14} className="mt-0.5 shrink-0 text-[var(--bb-terracotta)]" />
              <div className="leading-relaxed">
                <div className="font-medium text-[var(--bb-ink)]">Analytical and Creative Studio OPC Pvt Ltd</div>
                <div>3468 1st G Cross 7th Main RPC Layout</div>
                <div>Vijayanagar Bangalore 560040</div>
              </div>
            </div>
            <a href="mailto:info@balabasava.com" className="flex items-center gap-2 bb-link" data-testid="footer-contact-email">
              <Mail size={14} className="text-[var(--bb-terracotta)]" />
              info@balabasava.com
            </a>
            <a href="tel:+919164234566" className="flex items-center gap-2 bb-link" data-testid="footer-contact-phone">
              <Phone size={14} className="text-[var(--bb-terracotta)]" />
              +91 9164234566
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 pb-6 text-[11px] text-[var(--bb-muted)] leading-relaxed" data-testid="footer-business-line">
        {t("business_entity_line")}
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 border-t border-[var(--bb-border)] text-xs text-[var(--bb-muted)] flex flex-wrap items-center justify-between gap-3">
        <div>© {new Date().getFullYear()} {t("brand")}</div>
        <div className="bb-overline">{t("footer_tag")}</div>
      </div>
    </footer>
  );
}
